import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { Cell } from '../cell.model';

@Component({
  selector: 'app-cell',
  templateUrl: './cell.component.html',
  styleUrls: ['./cell.component.scss']
})
export class CellComponent implements OnInit {
  @Input('cell') cell: Cell;
  @Input('isShortVersionNeeded') isShortVersionNeeded: boolean;
  @Output('modelChanged') modelChanged: EventEmitter<any> = new EventEmitter();
  value;
  nachKommastellen: number = 4;
  validationCheck: boolean = true;
  constructor() { }
  valueCharCodes: number[] = [];
  ngOnInit() {
    this.value = this.cell.value;
    if(this.value == undefined){
      // if any value should be undefined -100 should help debugging the apropriate root of the problem (mostly if a matrix label is missing)
      this.value = -100;
    }
  }

  valueChanged() {
    //check if undefined or null because of the 0 Bug 
    if (this.value != undefined && this.value != null && !isNaN(this.value)) {
      this.cell.value = this.value;
      this.modelChanged.emit(this.cell);
    }
    else {
      // this.value = 0;
      this.cell.value = 0;
      this.modelChanged.emit(this.cell);
    }
  }

  onKeyFunc(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    //             101 = e            69 = E            45 = -       
    if (charCode == 101 || charCode == 69 || charCode == 45) {
      return false;
    }
    //check if undefined or null because of the 0 Bug 
    if (this.value != undefined || this.value != null) {
      //                                falls eine komma und punkt schon geschrieben wurde, dass man es nicht nochmal machen darf
      if (((this.value.toString().includes(',') || this.value.toString().includes('.')) && (charCode == 46 || charCode == 44)) || ((this.value.toString().includes(',') || this.value.toString().includes('.')) && (this.value.toString().replace(',', '.').split('.')[1].length >= this.nachKommastellen))) {
        return false;
      }
      if (charCode == 46 || charCode == 44) {
        this.validationCheck = false;
      }
      else {
        this.validationCheck = true;
      }
      this.cell.value = this.value;
      this.modelChanged.emit(this.cell);
    }
    else {
      this.validationCheck = true;
    }
    return true;
  }

  getLabelText(): string {
    let labelText: string = <string>this.value;

    if (labelText != undefined && labelText.length > 15 && this.isShortVersionNeeded == true) {
      let parts: string[] = labelText.split(' ');
      let tmpString: string = "";
      for (let index = 0; index < parts.length; index++) {
        const element = parts[index];
        tmpString += element[0];
      }
      return tmpString;
    }
    else {
      return labelText;
    }
  }
}
